// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"315":"e09e31826a8438f265f8","498":"e4cbf0e9ef04ec078136"}[chunkId] + "." + chunkId + ".web.js";
};